import styled from "styled-components";
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";
import {BalanceButtonsGroupDefaultBox} from "./balance-buttons-group.default.box";

export const BalanceButtonsGroupWSOPBox = styled(BalanceButtonsGroupDefaultBox)`
    ${CssRule.For.mobile.build()} &{
        background: transparent;
    }
`;
